import {helpers} from 'vuelidate/lib/validators'

const Base64Encoding = 'base64'

export const base64 = value => !helpers.req (value) ||
  Buffer.from (value, Base64Encoding).toString (Base64Encoding) === value
